import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ShieldCheck } from "lucide-react";
import { CONTACT_INFO, IMAGES } from "../data";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-zinc-950 text-stone-300 border-t border-zinc-900 py-16 px-6 md:px-12 rounded-none">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        {/* Column 1: Firm Info */}
        <div className="space-y-4">
          <Link to="/" className="flex items-center group">
            <img 
              src="https://assets.auxodev.dk/cdn-cgi/image/width=240,quality=90,format=auto/assets/bf156273-6242-48dd-a9a0-7699f46947d9/logo-nords-hvid.png" 
              alt="Nordsjællands Tømrer og Snedker" 
              className="h-10 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.02]"
            />
          </Link>
          <p className="text-xs text-stone-400 leading-relaxed pt-2">
            Professionelt tømrerarbejde, terrasser og tagarbejde i Helsingør og Nordsjælland. Vi bygger på solidt håndværk og personlig rådgivning.
          </p>
          <div className="flex flex-col gap-3 pt-1">
            <div className="flex items-center gap-2 text-xs text-stone-500">
              <ShieldCheck className="w-4 h-4 text-amber-600" />
              <span>CVR: {CONTACT_INFO.cvr}</span>
            </div>
          </div>
        </div>

        {/* Column 2: Contact Info */}
        <div className="space-y-4">
          <h3 className="text-xs font-bold uppercase tracking-widest text-stone-100 border-b border-zinc-800 pb-2">
            Kontakt os
          </h3>
          <ul className="space-y-3 text-xs">
            <li>
              <a
                href={`tel:${CONTACT_INFO.phone}`}
                className="flex items-center gap-3 text-stone-400 hover:text-amber-500 transition-colors duration-200 whitespace-nowrap"
              >
                <Phone className="w-4 h-4 text-amber-500 shrink-0" />
                <span>{CONTACT_INFO.phoneFormatted}</span>
              </a>
            </li>
            <li>
              <a
                href={`mailto:${CONTACT_INFO.email}`}
                className="flex items-center gap-3 text-stone-400 hover:text-amber-500 transition-colors duration-200 whitespace-nowrap"
              >
                <Mail className="w-4 h-4 text-amber-500 shrink-0" />
                <span>{CONTACT_INFO.email}</span>
              </a>
            </li>
            <li className="flex items-start gap-3 text-stone-400">
              <MapPin className="w-4 h-4 text-amber-500 shrink-0 mt-0.5" />
              <span className="leading-relaxed">{CONTACT_INFO.address}</span>
            </li>
          </ul>
        </div>

        {/* Column 3: Menu Links Left */}
        <div className="space-y-4">
          <h3 className="text-xs font-bold uppercase tracking-widest text-stone-100 border-b border-zinc-800 pb-2">
            Ydelser
          </h3>
          <ul className="space-y-2.5 text-xs">
            <li>
              <Link
                to="/toemrerarbejde"
                className="text-stone-400 hover:text-amber-500 transition-colors duration-200 block"
              >
                Tømrerarbejde
              </Link>
            </li>
            <li>
              <Link
                to="/terrasse"
                className="text-stone-400 hover:text-amber-500 transition-colors duration-200 block"
              >
                Træterrasser
              </Link>
            </li>
            <li>
              <Link
                to="/tagarbejde"
                className="text-stone-400 hover:text-amber-500 transition-colors duration-200 block"
              >
                Tagarbejde & Renovering
              </Link>
            </li>
            <li>
              <Link
                to="/murer-belaegning"
                className="text-stone-400 hover:text-amber-500 transition-colors duration-200 block"
              >
                Murer & Belægning
              </Link>
            </li>
          </ul>
        </div>

        {/* Column 4: Menu Links Right */}
        <div className="space-y-4">
          <h3 className="text-xs font-bold uppercase tracking-widest text-stone-100 border-b border-zinc-800 pb-2">
            Information
          </h3>
          <ul className="space-y-2.5 text-xs">
            <li>
              <Link
                to="/"
                className="text-stone-400 hover:text-amber-500 transition-colors duration-200 block"
              >
                Forside
              </Link>
            </li>
            <li>
              <Link
                to="/om-os"
                className="text-stone-400 hover:text-amber-500 transition-colors duration-200 block"
              >
                Om os
              </Link>
            </li>
            <li>
              <Link
                to="/kontakt"
                className="text-stone-400 hover:text-amber-500 transition-colors duration-200 block"
              >
                Kontakt os
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-zinc-900 flex flex-col sm:flex-row items-center justify-between gap-4 text-[10px] text-stone-500 uppercase tracking-widest">
        <div>
          &copy; {currentYear} {CONTACT_INFO.companyName}. Alle rettigheder forbeholdes.
        </div>
        <div>
          Solidt dansk håndværk · Helsingør
        </div>
      </div>
    </footer>
  );
}
